import * as React from 'react'
import styled from 'styled-components'

import * as S from '../styles'
import * as icons from '../svg/icons'

export type AccordionProps = {
  isOpen: boolean
  onToggle: () => void
  title: React.ReactNode
} & Omit<React.HTMLAttributes<HTMLDivElement>, 'title'>

function AccordionComponent({ children, isOpen, onToggle, title, ...divProps }: AccordionProps): React.ReactElement {
  return (
    <S.accordion.Wrapper isOpen={isOpen} {...divProps}>
      <S.accordion.Toggle onClick={onToggle}>
        <S.accordion.Title>{title}</S.accordion.Title>
        <icons.ChevronUp size={20} />
        <icons.ChevronDown size={20} />
      </S.accordion.Toggle>
      <S.accordion.Content>{children}</S.accordion.Content>
    </S.accordion.Wrapper>
  )
}

export const Accordion = styled(AccordionComponent)``
